<modal-header title="Select Party Size"></modal-header>

<ion-content>
    <ion-grid>
        <ion-row>
            <ion-col size-xs="12">
                <bb-select-buttons [options]="options"
                                   [selected]="partySize"
                                   [sizeLg]="4"
                                   [sizeXl]="3"
                                   [sizeSm]="6"
                                   (optionSelected)="onSubmit($event)">
                    <ng-template let-option #displayTemplate>
                        {{ option }}
                    </ng-template>
                </bb-select-buttons>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-content>
